import { LinksHelper } from '@/textControls';

import type { LinksManagerType } from '@wix/wix-richtext';

export class LinksManager implements LinksManagerType {
  constructor(private linksHelper: LinksHelper) {}

  convertExternalLinkToLinkRef(href: string) {
    return this.linksHelper.createLinkFromHref(href);
  }

  convertLinkRefToLinkRef(linkRef: AnyFixMe) {
    return this.linksHelper.duplicateLink(linkRef);
  }

  convertLinkRefToAttributes(linkRef: AnyFixMe) {
    const link: AnyFixMe = this.linksHelper.getLink(linkRef);

    if (link) {
      return { dataquery: `#${link.id}` };
    }

    return null;
  }

  convertAttributesToLinkRef(attributesObj: AnyFixMe) {
    return attributesObj.dataquery && attributesObj.dataquery.slice(1); //remove the leading #
  }
}
